import {immerable} from 'immer';

export default class TreeItem {
  [immerable] = true;

  update(obj) {
    Object.keys(obj).forEach((key) => {
      if (this[key] !== undefined) {
        this[key] = obj[key];
      }
    });
  }

  _identificator;
  get identificator() {
    return this._identificator;
  }
  set identificator(identificator) {
    this._identificator = identificator;
  }

  _label;
  get label() {
    return this._label;
  }
  set label(label) {
    this._label = label;
  }

  _active;
  get active() {
    return this._active;
  }
  set active(active) {
    this._active = active;
  }

  _children;
  get children() {
    return this._children;
  }
  set children(children) {
    this._children = children;
  }

  _collapsed;
  get collapsed() {
    return this._collapsed;
  }
  set collapsed(collapsed) {
    this._collapsed = collapsed;
  }

  constructor(data) {
    const {
      identificator = Math.random(),
      label = '',
      active = false,
      children = null,
      collapsed = null,
    } = data;
    this.identificator = identificator;
    this.label = label;
    this.active = active;
    this.children = children;
    this.collapsed = collapsed;
  }
}
